export const MAPTILER_KEY = 'Z5B8jvhQkar844lYLUif';